export const leaderboardPositionIcons = {
  first: require("../../../../assets/images/first-place.svg"),
  second: require("../../../../assets/images/second-place.svg"),
  third: require("../../../../assets/images/third-place.svg"),
};

export default function LeaderboardCard({ position, points }) {
  return (
    <div className="bg-white lg:max-w-[270px] w-full px-4 py-4 rounded border gap-4 flex items-center justify-center">
      <img src={leaderboardPositionIcons[position]} alt="" />
      <div className="flex flex-col gap-1">
        <p className="text-xs capitalize font-medium text-[#848484] ">
          {position?.toLowerCase()} place
        </p>
        <p className="text-xl">{points} points</p>
      </div>
    </div>
  );
}
